export const API_ENDPOINTS = {
    ASSISTANT: {
        CONVERSATIONS: '/assistant/conversations',
        CONVERSATION: (id) => `/assistant/conversations/${id}`,
        CONVERSATION_TITLE: (id) => `/assistant/conversations/${id}/title`,
        CONVERSATION_AGENT_MODE: (id) => `/assistant/conversations/${id}/agent-mode`,
        CONVERSE: (id) => `/assistant/conversations/${id}/converse`,
        MESSAGE: (id) => `/assistant/messages/${id}`,
        MESSAGE_FEEDBACK: (id) => `/assistant/messages/${id}/feedback`,
    },
    ACCEPTED_GRANTS: {
        STATISTICS: (id) => `/accepted-grants/${id}/statistics`,
        ACCEPTED_APPLICATIONS: (id, limit, offset, industry, region, revenue, size) => {
            const params = [
                `limit=${limit}`,
                `offset=${offset}`,
                industry ? `industry=${industry}` : undefined,
                region ? `region=${region}` : undefined,
                revenue ? `revenue=${encodeURIComponent(revenue)}` : undefined,
                size ? `size=${encodeURIComponent(size)}` : undefined,
            ]
                .filter(Boolean)
                .join('&');
            return `/accepted-grants/${id}/applications?${params}`;
        },
        FUNDING_INTELLIGENCE_STATISTICS: (locale, limit, page, industry, region, revenue, size, query) => {
            const params = [
                `locale=${locale}`,
                `limit=${limit}`,
                `page=${page}`,
                industry ? `industry=${encodeURIComponent(industry)}` : undefined,
                region ? `region=${encodeURIComponent(region)}` : undefined,
                revenue ? `revenue=${encodeURIComponent(revenue)}` : undefined,
                size ? `size=${encodeURIComponent(size)}` : undefined,
                query ? `query=${encodeURIComponent(query)}` : undefined,
            ]
                .filter(Boolean)
                .join('&');
            return `/funding-intelligence/statistics?${params}`;
        },
        FUNDING_INTELLIGENCE_COMPETITION: (locale, limit, page, industry, region, revenue, size, query) => {
            const params = [
                `locale=${locale}`,
                `limit=${limit}`,
                `page=${page}`,
                industry ? `industry=${encodeURIComponent(industry)}` : undefined,
                region ? `region=${encodeURIComponent(region)}` : undefined,
                revenue ? `revenue=${encodeURIComponent(revenue)}` : undefined,
                size ? `size=${encodeURIComponent(size)}` : undefined,
                query ? `query=${encodeURIComponent(query)}` : undefined,
            ]
                .filter(Boolean)
                .join('&');
            return `/funding-intelligence/applications?${params}`;
        },
    },
};
